module.exports = __webpack_public_path__ + "img/safe-home.50bb7579.svg";